/** `/c/$companyId/settings/approvals` — two-person approval and the default reviewer. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ApprovalsScreen } from "../approvals/ApprovalsScreen";
import { CODES } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";

export const Route = createFileRoute("/_auth/c/$companyId/settings/approvals")({
  component: ApprovalsRoute,
});

function ApprovalsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return (
    <CodeGate companyId={companyId} codes={[CODES.settings]}>
      <ApprovalsScreen companyId={companyId} />
    </CodeGate>
  );
}
